export const ACTIONS = {
	SET_LOADING: "SET_LOADING",
	INIT_CONFIGURATOR: "INIT_CONFIGURATOR",
	INIT_CONFIGURATOR_FULFILLED: "INIT_CONFIGURATOR_FULFILLED",
	INIT_CONFIGURATOR_FAILED: "INIT_CONFIGURATOR_FAILED",
	LOAD_OPTIONS_MATRIX: "LOAD_OPTIONS_MATRIX",
	LOAD_ADS_FABS: "LOAD_ADS_FABS",
	FORMAT_ADS_PATH_TREE: "FORMAT_ADS_PATH_TREE",
	LOAD_INTERIOR_MAP: "LOAD_INTERIOR_MAP",
	LOAD_EXTERIOR_MAP: "LOAD_EXTERIOR_MAP",
	ALL_DATA_LOADED: "ALL_DATA_LOADED",
	MISC_BUILD_CHANGE: "MISC_BUILD_CHANGE",
	POWERTRAIN_BUILD_CHANGE: "POWERTRAIN_BUILD_CHANGE",
	SAFETY_BUILD_CHANGE: "SAFETY_BUILD_CHANGE",
	INTERIOR_BUILD_CHANGE: "INTERIOR_BUILD_CHANGE",
	EXTERIOR_BUILD_CHANGE: "EXTERIOR_BUILD_CHANGE",
	INTERIOR_BUILD_SETTINGS_INIT: "INTERIOR_BUILD_SETTINGS_INIT",
	EXTERIOR_BUILD_SETTINGS_INIT: "EXTERIOR_BUILD_SETTINGS_INIT",
	BUILD_SETTINGS_BACKUP: "BUILD_SETTINGS_BACKUP",
	BUILD_SETTINGS_RESTORE: "BUILD_SETTINGS_RESTORE",
	BUILD_SETTINGS_BACKUP_CLEAR: "BUILD_SETTINGS_BACKUP_CLEAR",
	MAIN_NAV_CHANGE: "MAIN_NAV_CHANGE",
	VIEW_CHANGE: "VIEW_CHANGE",
	ACTIVE_OPTION_CHANGE: "ACTIVE_OPTION_CHANGE",
	OPTIONS_IN_VIEW_CHANGE: "OPTIONS_IN_VIEW_CHANGE",
	OPTIONS_IN_VIEW_SELECTION_CHANGE: "OPTIONS_IN_VIEW_SELECTION_CHANGE",
	FOCUSED_OPTION_CHANGE: "FOCUSED_OPTION_CHANGE",
	ACTIVE_DETAILS_CHANGE: "ACTIVE_DETAILS_CHANGE",
	OPTION_INTERACTED: "OPTION_INTERACTED",
	OPTION_SELECT: "OPTION_SELECT",
	SET_OPTION_CHILDREN: "SET_OPTION_CHILDREN",
	SET_CHILDREN_ACTIVE: "SET_CHILDREN_ACTIVE",
	PILLAR_CHANGE: "PILLAR_CHANGE",
	VIEW_OPTION_CHANGE: "VIEW_OPTION_CHANGE",
	ACTIVE_SUMMARY_CHANGE: "ACTIVE_SUMMARY_CHANGE",
	ACTIVE_FAB_CHANGE: "ACTIVE_FAB_CHANGE",
	ACTIVE_FAB_CLEAR: "ACTIVE_FAB_CLEAR",
	CAB_TYPE_CHANGE: "CAB_TYPE_CHANGE",
	CAB_CHANGE: "CAB_CHANGE",
	CAB_RESET: "CAB_RESET",
	QUOTE_SUBMITTED: "QUOTE_SUBMITTED",
	QUOTE_DISABLED: "QUOTE_DISABLED",

	// new actions for interior builder
	UI_UPDATE: "UI_UPDATE",
	UI_RESET: "UI_RESET",
	ROTATE_INTERIOR: "ROTATE_INTERIOR",
	RESIZE_INTERIOR: "RESIZE_INTERIOR",

	// new actions for exterior builder
	EXTERIOR_VIEW_STATE_UPDATE: "EXTERIOR_VIEW_STATE_UPDATE",
	RESET_EXTERIOR_VIEW: "RESET_EXTERIOR_VIEW",
	UPDATE_EXTERIOR_VIEW_HOTSPOTS: "UPDATE_EXTERIOR_VIEW_HOTSPOTS",
	UPDATE_EXTERIOR_VIEW_SIZE: "UPDATE_EXTERIOR_VIEW_SIZE",
	UPDATE_EXTERIOR_VIEW: "UPDATE_EXTERIOR_VIEW",
	UPDATE_EXTERIOR_VIEW_LAYERS: "UPDATE_EXTERIOR_VIEW_LAYERS",
	ROTATE_TRUCK_WITH_KEYS: "ROTATE_TRUCK_WITH_KEYS",
	DRAG_TRUCK: "DRAG_TRUCK",
	UPDATE_EXTERIOR_ACTIVE_FRAME: "UPDATE_EXTERIOR_ACTIVE_FRAME",
	RESIZE_EXTERIOR: "RESIZE_EXTERIOR",
	PAINT_CANVASES: "PAINT_CANVASES",
	PRECACHE_ACTIVE_OPTION: "PRECACHE_ACTIVE_OPTION",
	HACK_COLORS: "HACK_COLORS",
};